module.exports = __webpack_public_path__ + "img/rank1.94089c28.png";